import { h, Fragment, cn } from '../../../lib/vdom.js';
import * as I from './Icon.jsx';
import { openImageDialog } from './ImageDialog.jsx';
import {
  ImageCarousel,
  ImageCarouselScrollButtons,
  ImageCarouselScrollIndicator,
  initImageCarousel,
  type ImageData,
} from './ImageCarousel.jsx';

const PORTFOLIO_IMAGES: ImageData[] = [
  {
    src: '/public/portfolio/portals.png',
    caption: (
      <>
        <h2>Internal system for Intecredo International ApS</h2>
        <ul className="styled">
          <li>Custom CRM</li>
          <li>Human Resource Management System (HRMS)</li>
          <li>Document, Email, and Inventory management</li>
          <li>
            300K lines of code since <b>2016</b>
          </li>
        </ul>
      </>
    ),
  },
  {
    src: '/public/portfolio/chat-video.png',
    caption: (
      <>
        <h2>Audio/Video chat</h2>
        <ul className="styled">
          <li>Real-time audio/video streams over WebRTC</li>
          <li>Real-time text messages over WebSocket</li>
          <li>Screen sharing capabilities</li>
        </ul>
      </>
    ),
  },
  // {
  //   src: "/public/portfolio/chat.png",
  //   caption:
  //     "Our core mission is to automate your internal business processes.",
  // },
  {
    src: '/public/portfolio/document-portal-search.png',
    caption: (
      <>
        <h2>Document management</h2>
        <ul className="styled">
          <li>Manage millions of internal PDFs</li>
          <li>Fast search by content, tags etc</li>
          <li>Integrated PDF and image viewers</li>
          <li>Multilingual OCR and text extraction from PDFs</li>
          <li>RESTful APIs</li>
        </ul>
      </>
    ),
  },
  // {
  //   src: "/public/portfolio/document-portal-sidebar.png",
  //   caption:
  //     "Our core mission is to automate your internal business processes.",
  // },
  // {
  //   src: "/public/portfolio/document-portal-pdf-preview.png",
  //   caption:
  //     "Our core mission is to automate your internal business processes.",
  // },
  // {
  //   src: "/public/portfolio/workflow-link.png",
  //   caption:
  //     "Our core mission is to automate your internal business processes.",
  // },
  {
    src: '/public/portfolio/workflow-params.png',
    caption: (
      <>
        <h2>Workflow creator</h2>
        <ul className="styled">
          <li>Managing complex workflows</li>
          <li>Visualize and automate complex business logic</li>
        </ul>
      </>
    ),
  },
  {
    src: '/public/portfolio/email-portal-list.png',
    caption: (
      <>
        <h2>Email management</h2>
        <ul className="styled">
          <li>Automatic handling of requests based on predefined email templates</li>
          <li>Search emails by contents and attachments</li>
          <li>Integrated with the document management system</li>
        </ul>
      </>
    ),
  },
  // {
  //   src: "/public/portfolio/email-portal-pdf-preview.png",
  //   caption:
  //     "Our core mission is to automate your internal business processes.",
  // },
  // {
  //   src: "/public/portfolio/email-portal-right-sidebar.png",
  //   caption:
  //     "Our core mission is to automate your internal business processes.",
  // },
  // {
  //   src: "/public/portfolio/event-disc.png",
  //   caption:
  //     "Our core mission is to automate your internal business processes.",
  // },
  {
    src: '/public/portfolio/event-disc-sidebar.png',
    caption: (
      <>
        <h2>Circular calendar</h2>
        <ul className="styled">
          <li>A creative way to manage your busy schedule</li>
          <li>Zoom in for nested calendars</li>
        </ul>
      </>
    ),
  },
  {
    src: '/public/portfolio/keyboard-shortcuts.png',
    caption: (
      <>
        <h2>Extensive keyboard shortcuts to speed up workflows</h2>
        <ul className="styled">
          <li>Fast navigation throughout portals</li>
        </ul>
      </>
    ),
  },
  {
    src: '/public/portfolio/case-portal-customizable-layout.png',
    caption: (
      <>
        <h2>Customizable page layouts for each user</h2>
        <ul className="styled">
          <li>Drag & drop widgets</li>
          <li>Custom event timelines</li>
        </ul>
      </>
    ),
  },
  {
    src: '/public/portfolio/case-portal-more-actions.png',
    caption: (
      <>
        <h2>And a lot more ...</h2>
        <ul className="styled">
          <li>Integrated with Asterisk for VoIP Phonecalls</li>
          <li>Create notes, assignments, payment agreements etc.</li>
          <li>Timeline of events</li>
        </ul>
      </>
    ),
  },
  {
    src: '/public/portfolio/unforget-screenshots.png',
    withoutShadow: true,
    caption: (
      <>
        <h2>Unforget: minimalist note taking app</h2>
        <ul className="styled">
          <li>
            <a href="https://news.ycombinator.com/item?id=40645743" target="_blank" className="styled">
              <b>Featured on Hacker News</b>
            </a>
          </li>
          <li>End-to-end encrypted</li>
          <li>Desktop, mobile, and web</li>
          <li>Self-hosted and cloud options</li>
          <li>Progressive Web App (PWA)</li>
          <li>
            <a href="https://github.com/computing-den/unforget" target="_blank" className="styled">
              Open source
            </a>{' '}
            MIT License
          </li>
          <li>
            <a href="https://unforget.computing-den.com/demo" target="_blank" className="styled">
              Try it now
            </a>
          </li>
        </ul>
      </>
    ),
  },
];

export default function Portfolio() {
  return (
    <section id="portfolio">
      <div className="heading-content">
        <h3 className="section-subheading">PORTFOLIO</h3>
        <div className="section-heading-and-buttons">
          <h1 className="section-heading">What Have We Done?</h1>
          <ImageCarouselScrollButtons />
        </div>
      </div>
      <ImageCarouselScrollIndicator count={PORTFOLIO_IMAGES.length} />
      <ImageCarousel images={PORTFOLIO_IMAGES} />
    </section>
  );
}

export function initPortfolio() {
  initImageCarousel({
    parent: document.getElementById('portfolio')!,
    onImageClick: imageClicked,
  });

  function imageClicked(e: MouseEvent, index: number) {
    openImageDialog(PORTFOLIO_IMAGES, index);
  }
}
